<template>
    <div @mouseover="isHovered = true"
         @mouseleave="isHovered = false"
         class="battery-item">
        <div class="position-relative">
            <AppUserAvatar :user="user"/>
        </div>
        <div v-if="!disabled && isHovered"
             @click.stop="$emit('remove', user)"
             class="battery-item-remove">
            <span class="text-white">
                <i class="fa fa-times"></i>
            </span>
        </div>
    </div>
</template>

<script>
import AppUserAvatar from '../../../setters/AppUserAvatar'

export default {
    name: 'AppSelectUserBatteryItem',
    components: {AppUserAvatar},
    props: {
        user: {
            type: Object,
            required: true
        },
        disabled: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            isHovered: false
        }
    }
}
</script>

<style lang="scss" scoped>
$border: 1px solid white;

.battery-item {
    height: 29px;
    border: $border;
    position: relative;
    display: inline-block;
    border-radius: 100%;
}

.battery-item-remove {
    position: absolute;
    display: inline-block;
    vertical-align: center;
    background: grey;
    border: $border;
    border-radius: 100%;
    top: -6px;
    right: -6px;
    width: 18px;
    height: 18px;
    font-size: 12px;
    line-height: 16px;
    text-align: center;

    &:hover {
        cursor: pointer;
        background: $color-danger;
    }
}
</style>
